import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/lump-sum-vs-dca-calculator',
  component: () => import('../../routes/LumpSumVsDcaCalculator.svelte'),
  card: {
    id: 'lump-sum-vs-dca-calculator',
    title: 'Lump Sum vs DCA',
    description:
      'Compare investing a lump sum now versus dollar-cost averaging over time. See which strategy yields higher returns based on amount, timeline, and expected return.',
    icon: 'comparison',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/lump-sum-vs-dca-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Lump Sum vs DCA Calculator – Dollar Cost Averaging vs Lump Sum Investing',
    description:
      'Compare lump sum investing versus dollar-cost averaging (DCA). Enter your investment amount, monthly contribution, expected return, and timeline to see which strategy wins.',
  },
};

export default meta;